import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { updateGameType } from '../../actions/user-actions-types';
import { View } from '..';
import constants from '../../constants';
import { isBannedStateForPoker } from '../../utilities/helper';
import GamesPoster from '../games_poster';
import TabBar from '../tabs';
import { useLink } from 'react-router-stack';
import './index_web.css';
import { showToast } from '../../actions/app-actions-types';
import { addGameToHistory, setMiniGamesData } from '../../actions/mini-games-action-types';

const MatchTabHomeWeb = ({
  gameTypes,
  quizGames,
  sportsGames,
  arcadeGames,
  racingGames,
  puzzleGames,
  strategyGames
}: any) => {
  const [activeTab, setActiveTab] = useState(0);

  const currentLocationState = useSelector((state: any) => state.app.currentLocationState);
  const { gamesHistory = [] } = useSelector((state: any) => state.minigames);

  const isBannedPoker = isBannedStateForPoker(currentLocationState);

  const dispatch = useDispatch();
  const navigate = useLink();

  const onChangeIndex = (index = 0) => {
    setActiveTab(index);
  };
  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onPressFantasyCricket = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
    navigate.push('/fantasy', {
      title: 'Fantasy Cricket',
      gameType: constants.GameType.FANTASY_CRICKET
    });
  };

  const onPressFantasyFootball = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_FOOTBALL));
    navigate.push('/fantasy', {
      title: 'Fantasy Football',
      gameType: constants.GameType.FANTASY_FOOTBALL
    });
  };
  const onPressYesNo = () => {
    dispatch(updateGameType(constants.GameType.FANTASY_YES_NO));
    navigate.push('/fantasy', {
      title: 'Fantasy Yes/No',
      gameType: constants.GameType.FANTASY_YES_NO
    });
  };

  const onPressPoker = () => {
    if (isBannedPoker) {
      let message = 'Sorry, this game is not playable in your location ';
      message += currentLocationState ? ` "${currentLocationState}".` : '.';
      dispatch(showToast(message));
      return;
    }
    dispatch(updateGameType('POKER'));
    navigate.push('/poker');
  };
  const gameClickHandler = (game: any) => {
    dispatch(addGameToHistory(game));
    if (game.gameType && game.gameType === 'minigame') {
      dispatch(setMiniGamesData(game));
      navigate.push('/prizes');
    }
    if (game.gameType === 'playerVsPlayer') {
      dispatch(setMiniGamesData(game));
      navigate.push('/match_making');
    }
    if (game.game === 'cricket') {
      onPressFantasyCricket();
    }
    if (game.game === 'football') {
      onPressFantasyFootball();
    }
    if (game.game === 'poker') {
      onPressPoker();
    }
    if (game.game === 'yesorno') {
      onPressYesNo();
    }
    if (game.game === 'leaderboard') {
      navigate.push('/leaderboard_games');
    }
    if (game.game === 'pvp') {
      navigate.push('/pvp_games');
    }
  };

  return (
    <View className="home_tab_match-tab-wrapper flat-list-outer-grow">
      <TabBar activeTab={activeTab} onChangeTab={onChangeTab} routes={gameTypes} />
      <div className="flat-list-outer-grow">
        <SwipeableViews
          className="swipeable-view-outer-container"
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 0 && (
              <GamesPoster
                games={constants.MiniGames.newGamesList}
                gameClickHandler={gameClickHandler}
                id={activeTab}
              />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 1 && (
              <GamesPoster
                games={gamesHistory}
                gameClickHandler={gameClickHandler}
                id={activeTab}
              />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 2 && (
              <GamesPoster
                games={constants.MiniGames.cardsGame}
                gameClickHandler={gameClickHandler}
                id={activeTab}
              />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 3 && (
              <GamesPoster games={quizGames} gameClickHandler={gameClickHandler} id={activeTab} />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 4 && (
              <GamesPoster games={sportsGames} gameClickHandler={gameClickHandler} id={activeTab} />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 5 && (
              <GamesPoster games={arcadeGames} gameClickHandler={gameClickHandler} id={activeTab} />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 6 && (
              <GamesPoster games={racingGames} gameClickHandler={gameClickHandler} id={activeTab} />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 7 && (
              <GamesPoster games={puzzleGames} gameClickHandler={gameClickHandler} id={activeTab} />
            )}
          </View>
          <View className={'home_tab_match-tab-content'}>
            {activeTab === 8 && (
              <GamesPoster
                games={strategyGames}
                gameClickHandler={gameClickHandler}
                id={activeTab}
              />
            )}
          </View>
        </SwipeableViews>
      </div>
    </View>
  );
};

export default MatchTabHomeWeb;
